import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination as RaPagination } from "react-admin";
export const Pagination = (props) => (_jsx(RaPagination, { rowsPerPageOptions: [10, 25, 50, 100, 250], ...props }));
